define('SageDotCom/Components/LottieAnimation',["jquery"], function ($) {
    function LottieAnimation(scope) {
        if (typeof lottie === "undefined") {
            return;
        }

        var prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        var lottieEl = scope.querySelector(".lottie-container");
        if (!lottieEl) return;

        var lottiePath = lottieEl.getAttribute("data-path");
        var lottieControl = lottieEl.querySelector(".lottie-control");
        var finished = false;
        var animation = null;
        var loaded = false;

        function initAnimation() {
            if (loaded) return;
            loaded = true;

            animation = lottie.loadAnimation({
                container: lottieEl.querySelector(".lottie-animation-content") || lottieEl,
                renderer: "svg",
                loop: false,
                autoplay: false,
                path: lottiePath
            });

            bindAnimationEvents();
        }

        function play() {
            if (!animation) return;
            if (finished) {
                animation.stop();
            }

            lottieControl.classList.add("playing");
            animation.play();
            finished = false;
        }

        function pause() {
            if (!animation) return;
            lottieControl.classList.remove("playing");
            animation.pause();
        }

        function bindAnimationEvents() {
            animation.addEventListener("complete", function () {
                lottieControl.classList.remove("playing");
                finished = true;
            });

            animation.addEventListener("DOMLoaded", function () {
                if (prefersReducedMotion) {
                    animation.goToAndStop(animation.totalFrames - 1, true);
                    lottieControl.classList.remove("playing");
                    finished = true;
                }
            });
        }

        lottieControl.addEventListener("click", function (e) {
            if (lottieControl.classList.contains("playing")) {
                pause();
            } else {
                play();
            }
        });

        var observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting && entry.target === lottieEl) {
                    initAnimation();
                    if (animation) {
                        lottieControl.classList.add("playing");
                        animation.play();
                    }
                    observer.disconnect();
                }
            });
        }, {
            rootMargin: "200px", // preload before entering viewport
            threshold: 0.25
        });

        observer.observe(lottieEl);

        this.destroy = function () {
            observer.disconnect();
            if (animation) {
                animation.destroy();
            }
            var clone = lottieEl.cloneNode(true);
            lottieEl.parentNode.replaceChild(clone, lottieEl);
        };
    }

    LottieAnimation.init = function init(args) {
        if (args.IsEditorEditing === true) return null;
        return new LottieAnimation(args.scope);
    };

    return LottieAnimation;
});

